import * as React from 'react';
export const CFSvg = React.forwardRef(function CFSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1.994 0h12.012C15.106 0 16 .895 16 2v1H0V2C0 .888.893 0 1.994 0Z',
      }),
      /*#__PURE__*/ React.createElement('rect', {
        width: 1,
        height: 1,
        x: 2,
        y: 1,
        fill: '#FCD669',
        rx: 0.5,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 3h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 6h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 6V3h1v3h-1ZM0 3h1v3H0V3Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 9h16v1c0 1.112-.893 2-1.994 2H1.994C.894 12 0 11.105 0 10V9Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 9v1a1 1 0 0 1-1 1H2c-.555 0-1-.447-1-1V9H0v1c0 1.106.893 2 2 2h12a2 2 0 0 0 2-2V9h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M6 0h4v12H6z',
      }),
    ),
  );
});
CFSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CF = {
  category: 'flag',
  colorable: false,
  name: 'CF',
  svg: CFSvg,
};
